define.alias("ember-truth-helpers/helpers/is-array", "calendar/helpers/is-array");